
import outSideClick from "./outsideCLick"

export default function dropdown() {
	const dropdownMenus = document.querySelectorAll('[js-dropdown]');

	dropdownMenus.forEach(menu => {
		['touchstart', 'click',].forEach(userEvent => {
			menu.addEventListener(userEvent, handleClick);

		});

	});

	function handleClick(event) {
		// Fechar notificações: o wrapper tem js-dropdown; touchstart/click no botão
		// sobe até aqui e, sem este guard, re-aplica "active" e impede o fechamento.
		if (event.target.closest("[js-notificacoes-fechar]")) {
			if (typeof window.notificacoesFecharDropdowns === "function") {
				window.notificacoesFecharDropdowns();
			} else {
				document.querySelectorAll("[js-dropdown-notificacao]").forEach((d) => d.classList.remove("active"));
				document.getElementById("menu-header")?.classList.remove("menu-header--notif-open");
			}
			return;
		}
		// event.preventDefault(); //retirar se tiver click no item
		dropdownMenus.forEach(i => i.classList.remove("active"))
		this.classList.add('active');
		if (typeof window.notificacoesSyncMenuHeader === "function") {
			window.notificacoesSyncMenuHeader();
		}

		// outside click pode ser reaproveitado para outros eventos de bubble
		outSideClick(this, ['touchstart', 'click', "mouseleave"], () => { //ativa o outside click com os eventos 
			this.classList.remove("active")
			if (typeof window.notificacoesSyncMenuHeader === "function") {
				window.notificacoesSyncMenuHeader();
			}
		})
	}

}